import NotFound from 'pages/404'
import EventIndex from 'pages/event'
import AddCheckpoint from 'pages/event/AddCheckpoint'
import EventDetail from 'pages/event/Detail'
import EventRegister from 'pages/event/Register'
import EventResult from 'pages/event/Result'
import EventSurvey from 'pages/event/Survey'
import UpdateCheckpoint from 'pages/event/UpdateCheckpoint'
import OrganizerIndex from 'pages/organizer'
import Quiz from 'pages/Quiz'
import QuizRegister from 'pages/Quiz/Register'
import Home from 'pages/Home'
import Login from 'pages/Login'

interface RouterData {
  path: string
  element: () => JSX.Element | null
  useLayout: boolean
}
export const publicRoutes: RouterData[] = [
  {
    path: '*',
    element: NotFound,
    useLayout: true,
  },
]

export const authRoutes: RouterData[] = [
  {
    path: '/login',
    element: Login,
    useLayout: true,
  },
]

export const privateRoutes: RouterData[] = [
  {
    path: '/event/register',
    element: EventRegister,
    useLayout: true,
  },
  {
    path: '/event/:id/update-point/:pid',
    element: UpdateCheckpoint,
    useLayout: true,
  },
  {
    path: '/event/:id/add-point',
    element: AddCheckpoint,
    useLayout: true,
  },
  {
    path: '/event/:id/result',
    element: EventResult,
    useLayout: true,
  },
  {
    path: '/event/:id/survey',
    element: EventSurvey,
    useLayout: true,
  },
  {
    path: '/event/:id',
    element: EventDetail,
    useLayout: true,
  },
  {
    path: '/event',
    element: EventIndex,
    useLayout: true,
  },
  {
    path: '/organizer',
    element: OrganizerIndex,
    useLayout: true,
  },
  {
    path: '/quiz/register',
    element: QuizRegister,
    useLayout: true,
  },
  {
    path: '/quiz',
    element: Quiz,
    useLayout: true,
  },
  {
    path: '/',
    element: Home,
    useLayout: true,
  },
]
